<template>
  <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
    <div class="subscribe-list" v-for="item in askList" :key="item.id">
      <div class="subscribe-list-right">
        <p>{{ item.apply_time }} {{ item.title }}</p>
        <p>{{ item.success_time }}</p>
      </div>
      <p class="subscribe-list-suc">预约成功</p>
    </div>
  </van-list>
</template>
<script setup>
import { ref } from "vue";
import ajax from "@/utils/request.js";

const askList = ref([]);

const page = ref(1);
const loading = ref(false);
const finished = ref(false);

function getAskList () {
  loading.value = true;
  const data = {
    typeid: 4,
    page: page.value,
  };
  return ajax.post("users/getforumlist", data).then((res) => {
    console.log(res);
    if (res.data.length < 10) {
      askList.value = askList.value.concat(res.data);
      finished.value = true;
    } else {
      askList.value = askList.value.concat(res.data);
      page.value++;
    }
  }).catch(() => {
    finished.value = true;
  });
}
getAskList().finally(() => {
  loading.value = false;
});

const onLoad = () => {
  getAskList().finally(() => {
    loading.value = false;
  });
}
</script>
<style scoped>
.subscribe-list {
  background-color: #fff;
  padding: 4.2667vw 4vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.subscribe-list-right p {
  font-size: 14px;
}
.subscribe-list-right p:first-child {
 font-family: 苹方-简 中黑体;
  color: #333333;
}
.subscribe-list-right p:last-child {
  color: #666666;
  margin-top: 4.2667vw;
}
.subscribe-list-suc {
  color: #ff0000;
  font-size: 14px;
}
</style>